/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardOrderCustomerResponseViewModel } from "../types/CreditCardOrderCustomerResponseViewModel.ts";

export const creditCardOrderCustomerResponseViewModelSchema = z.object({
  name: z.string().nullish(),
  email: z.string().nullish(),
  document: z.string().nullish(),
  documentType: z.string().nullish(),
}) as unknown as ToZod<CreditCardOrderCustomerResponseViewModel>;
